import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classnames from 'classnames';
import React__default, { useState, useRef, useEffect, useCallback } from 'react';
import alertUserOfDeprecatedProps from '../../utils/deprecation.js';

var _excluded = ["className", "disabled", "error", "grow", "highlight", "onChange", "size", "value"];

// Allows the use of a local ref but while support an external one
// https://itnext.io/reusing-the-ref-from-forwardref-with-react-hooks-4ce9df693dd
function useCombinedRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  var targetRef = React__default.useRef();
  React__default.useEffect(function () {
    refs.forEach(function (ref) {
      if (!ref) return;
      if (typeof ref === 'function') {
        ref(targetRef.current);
      } else {
        ref.current = targetRef.current;
      }
    });
  }, [refs]);
  return targetRef;
}
var recalculateTextareaHeight = function recalculateTextareaHeight(element, height, setHeight) {
  var newHeight = element.scrollHeight;
  if (height !== newHeight) {
    if (element.value === '' && height) {
      setHeight(0);
    } else if (newHeight) {
      setHeight(newHeight);
    }
  }
};
var RawFormTextarea = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    disabled = _ref.disabled,
    error = _ref.error,
    grow = _ref.grow,
    highlight = _ref.highlight,
    onChange = _ref.onChange,
    size = _ref.size,
    value = _ref.value,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  alertUserOfDeprecatedProps('InputTextarea', otherProps);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    height = _useState2[0],
    setHeight = _useState2[1];
  var textareaElement = useRef(null);
  var combinedRef = useCombinedRefs(ref, textareaElement);
  useEffect(function () {
    grow && recalculateTextareaHeight(combinedRef.current, height, setHeight);
  }, [value, grow, height]);
  var changeEvent = useCallback(function (event) {
    onChange && onChange(event);
    grow && recalculateTextareaHeight(event.target, height, setHeight);
  }, [grow, height, onChange]);
  var finalClasses = classnames('C-Input --type-textarea', _defineProperty({
    '--grow': grow,
    isDisabled: disabled,
    isErrored: error,
    isHighlighted: highlight
  }, "--size-".concat(size), size), className);
  return /*#__PURE__*/React__default.createElement("textarea", _extends({
    className: finalClasses,
    disabled: disabled,
    onChange: changeEvent,
    ref: combinedRef,
    value: value,
    style: grow ? {
      height: "".concat(height, "px"),
      resize: 'none'
    } : {}
  }, otherProps));
});
RawFormTextarea.displayName = 'Form.Textarea';
var FormTextarea = /*#__PURE__*/React__default.memo(RawFormTextarea);

export { RawFormTextarea, FormTextarea as default, recalculateTextareaHeight };
